var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRedFish(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 83,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.07 25.64a45.51 45.51 0 0113.67-4.84 39.5 39.5 0 00-3.92-.7c-5.98-.74-16.42 4.6-19.74 8.54-2.04 2.42-2.2 6.1-2 8.58a32.05 32.05 0 0111.99-11.58z",
    fill: "#C00000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.04 24.75c-6.65 3.63-10.38 9.78-11.97 12.47.06.9.19 1.79.37 2.67l38.43-12.6-.4-2.82s-6.92-2.38-12.73-3.67c-4.8.85-9.56 1.68-13.7 3.95z",
    fill: "#A70000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.84 50.11s7.18 4.35 9.09 9.22c3.4 8.69 25.83 7.74 32.42.11 4.73-5.47 5.75-5.17 5.75-5.17s-46.8-10.8-47.26-4.16z",
    fill: "#900000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53.42 47.5c9.74-3.08 13.64-13.41 14.85-19.43-6.37-4.8-14.98-5.85-25.04-3.39-13.51 3.3-19.98 14.67-21.05 16.8-.14.27-.3.52-.51.74 9.03 3.53 23.22 8 31.75 5.29z",
    fill: "#FF3200"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M74.01 34.34a23.86 23.86 0 00-5.74-6.27c-1.2 6.02-5.12 16.35-14.85 19.44-8.53 2.7-22.7-1.77-31.75-5.29-1.3 1.5-3.61 1.78-3.61 1.78l1.1 6.16s1.84-.9 14.87 6.6c13.02 7.49 28.53 2.64 32.92-.73 4.4-3.37 13.45-11.72 7.06-21.7z",
    fill: "#DD0020"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M73.71 28.78a6.16 6.16 0 01-4.38 7.54c-3.3.87-5.55-.96-6.42-4.25-.87-3.29-.03-6.8 3.27-7.67a6.16 6.16 0 017.53 4.38z",
    fill: "#910005"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M73.65 27.58a6.16 6.16 0 11-11.92 3.15 6.16 6.16 0 0111.92-3.15z",
    fill: "#D20008"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M60.36 32.1a7.2 7.2 0 11-3.45 13.98 7.2 7.2 0 013.45-13.98z",
    fill: "#910005"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M59.48 31.05a7.2 7.2 0 11-3.45 13.98 7.2 7.2 0 013.45-13.98z",
    fill: "#D20008"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M71.85 28.62a4.11 4.11 0 11-7.95 2.1 4.11 4.11 0 017.95-2.1z",
    fill: "#fff"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3 30.2a1.27 1.27 0 11-2.51-.31 1.27 1.27 0 012.51.31z",
    fill: "#000"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M59.65 33.98a4.8 4.8 0 11-2.28 9.33 4.8 4.8 0 012.28-9.33z",
    fill: "#fff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M59.27 37.74a1.57 1.57 0 11-.75 3.05 1.57 1.57 0 01.75-3.05zM72.18 42.11a2.33 2.33 0 11-4.54 1.05 2.33 2.33 0 014.54-1.05z",
    fill: "#000"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M36.88 38.54a2.77 2.77 0 11-5.4 1.25 2.77 2.77 0 015.4-1.25zM45.99 40.44a1.58 1.58 0 11-3.07.71 1.58 1.58 0 013.07-.71zM28.26 42.21a1.58 1.58 0 11-3.07.7 1.58 1.58 0 013.07-.7zM42.4 34.17a1.75 1.75 0 11-3.41.8 1.75 1.75 0 013.4-.8zM51.88 28.8a2.33 2.33 0 11-4.55 1.04 2.33 2.33 0 014.55-1.04z",
    fill: "#900000"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M10.75 45.74c2.67 1.23.4 6.27 2.46 6.05 1.57-.16 3.68-9.06 8.42-9.26a98.61 98.61 0 001.79-3.56c-3.59 4.22-8.86-6.5-12.34-6.1-3.47.41.21 6.92.21 6.92s-3.9-.52-4.6 2.43c.96 1.18 2.47 2.78 4.06 3.52z",
    fill: "#D70000"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M13.21 51.8c-2.07.2.21-4.82-2.46-6.06-1.59-.74-3.1-2.33-4.06-3.52-.1.4-.13.82-.1 1.24.2 4.32 5.23 3.75 3.16 6.82-2.07 3.06 2.18 6.83 6.04 3.77 3.87-3.07 5.74-3.53 5.74-3.53s2.04-1.47.46-4.88a5.03 5.03 0 01-.34-3.1c-4.76.19-6.87 9.09-8.44 9.25z",
    fill: "#B20000"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M62.98 25.1c-.29-.22-.6-.43-.91-.63-.95-.55-1.96-.98-3.01-1.27-2.07-.55-4.2-.79-6.33-.72-2.1.04-4.2.26-6.26.64-2.06.37-4.1.88-6.1 1.52-2 .68-3.93 1.53-5.78 2.56a29.68 29.68 0 00-5.22 3.73 26.98 26.98 0 00-4.3 4.87c-1.2 1.82-2.7 4.3-3.3 6.47a32.52 32.52 0 013.96-5.71 31.55 31.55 0 014.43-4.53 35.73 35.73 0 0110.74-5.7 50.4 50.4 0 015.9-1.55c1.98-.44 4-.74 6.03-.92 2.03-.19 4.07-.12 6.09.2 1.02.15 2.02.44 2.97.84.3.14.6.3.89.47.06-.1.13-.18.2-.26z",
    fill: "#FF5100"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedFish);
export default __webpack_public_path__ + "static/media/red-fish.98da5b7450580183ffb356835e329616.svg";
export { ForwardRef as ReactComponent };